import React, { useState } from "react";
import RenderLabel from "../../components/Form/Renderer/RenderLabel";
import Button from "../../common/ui/Button";
import ContainerHeader from "../../common/ui/ContainerHeader";
import { Image } from "../../common/ui/Image";
import ResendOTP from "../../common/ui/otp/ResendOTP";
import { emailRegex } from "../../utils/helper/string";
import { toastMessage } from "../../utils/helper/myToast";
import { sendResetPasswordLink } from "../../services/public.services";
import { FieldErrorMessage } from "@/common/ui/Text";

interface Props {
  userTypeKey: string;
}
const SendResetPasswordLink: React.FC<Props> = ({ userTypeKey }) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const disabled = false;

  const handleSendResetLink = async () => {
    if (email && emailRegex.test(email)) {
      setIsLoading(true);
      try {
        const res: any = await sendResetPasswordLink({ email }, `?type=${userTypeKey}`);

        if (res?.status === 200) {
          const { message, isError } = res.data;
          setSuccess(true);
          return toastMessage(message, isError);
        } else {
          console.log("Error", res);
          const { message, isError } = res?.response?.data || {};
          if (message) {
            return toastMessage(message, isError);
          }
          if (res.message) {
            return toastMessage(res.message, true);
          }
        }
      } catch (err) {
        console.log({ err });
      } finally {
        setIsLoading(false);
      }
    } else {
      return setError("Enter a valid email address.");
    }
  };

  const handleOnChange = (text: string) => {
    if (error) setError("");
    setEmail(text);
  };

  const resendOtp = async () => await sendResetPasswordLink({ email }, `?key=resend&type=${userTypeKey}`);

  return (
    <div className="mt-12 w-full md:w-[400px] shadow-form rounded-llg">
      {success ? (
        <div className=" flex flex-col items-center p-6 gap-2 pb-32 md:pb-6">
          <Image src="/images/mail-sent.svg" alt="email-send-image" className=" hover:cursor-pointer" />
          <ContainerHeader headingClassName=" text-xl !leading-normal font-black text-text-label" heading="Link sent successfully!" />
          <p className="text-text-label text-sm text-center w-full py-1 px-2">
            We've sent you a password reset link to your email. <br />
            Please check spam just in case!
          </p>
          <ResendOTP
            text="Didn't receive the email?"
            linkText="Click resend"
            resendOtpAPI={resendOtp}
            className="text-center md:px-4 !mt-1"
            errorMessage={error}
            resetErrorMessage={() => setError("")}
          />
        </div>
      ) : (
        <div className={` p-6`}>
          <h2 className="font-bold text-xl md:text-2xl text-center pb-2 text-text-label">Forgot password</h2>
          <p className="text-text-label text-10 md:text-sm text-center w-full">Please enter your registered e-mail id.</p>

          <div className=" flex flex-col gap-2">
            <RenderLabel label="Email" required className=" text-nowrap " />
            <input
              type="text"
              placeholder="Enter your email"
              className={`w-full px-3 py-7 text-13 rounded-lg outline-none border border-gray-300 hover:border-gray-400 focus:border-text-primary-500 ${
                disabled ? "cursor-not-allowed" : " cursor-text"
              }`}
              autoComplete="on"
              value={email}
              onChange={(e: any) => handleOnChange(e.target.value)}
            />
            {error && <FieldErrorMessage text={error} className="!mt-0" />}
            <Button variant="primary" size="small" disabled={!email} isFullWidth className=" mt-5" onClick={handleSendResetLink} isLoading={isLoading}>
              Reset password
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SendResetPasswordLink;
